import { connect } from "react-redux"
import { sendAction } from "shared/djangio/action-creators"
import PeopleSelector from "app/static/frontend/components/PeopleSelector"

export default connect(null, { sendAction })(PeopleSelector)
